<template>
  <section>
    <v-container class="text-center">
      <h2 class="display-2 font-weight-bold mb-3">{{appName.toUpperCase()}} PRICING</h2>

      <v-responsive class="mx-auto mb-8" width="56">
        <v-divider class="mb-1"></v-divider>

        <v-divider></v-divider>
      </v-responsive>

      <v-responsive class="mx-auto title font-weight-light" max-width="720">
        <p>{{appName.toUpperCase()}} has a flexible pricing model.</p>
        <p>Base features are included in the base product fee and other modules can be activated at any time for an additional monthly fee.</p>
        <p>Pricing tiers are based on the total number of members in all your groups.</p>
      </v-responsive>

      <v-avatar
        class="elevation-12 my-4"
        :color="$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-5'"
        size="120"
      >
        <v-img contain max-height="80%" :src="getLogo()"></v-img>
      </v-avatar>

      <v-responsive class="mx-auto title font-weight-light" max-width="720">
        <p>View the additional costs for pricing tiers and add-on modules in the app!</p>
      </v-responsive>
    </v-container>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    getLogo() {
      var images = require.context("@/assets/", false, /\.png$/);
      return images(
        this.$vuetify.theme.dark
          ? "./GroupBot-Logo-Dark.png"
          : "./GroupBot-Logo-Light.png"
      );
    }
  },
  computed: {
    ...mapState("app", ["appName"])
  }
};
</script>